
import { createSlice} from "@reduxjs/toolkit";

import { FetchActivitiesByKeyword ,FetchFoodPreferencesByKeyword } from './thunk';
import { fetchExerciseCategories } from "./thunk"
const exerciseCategoriesSlice = createSlice({
    name: "exerciseCategories",
    initialState: {
      categories: [],
      activitiesBD: [],
      foodPreferences: [],
      status: "",
      loading: false,
      error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
      builder
        .addCase(fetchExerciseCategories.pending, (state) => {
          state.status = "loading";
        })
        .addCase(fetchExerciseCategories.fulfilled, (state, action) => {
          state.status = "succeeded";
          state.categories = action.payload;
        })
        .addCase(fetchExerciseCategories.rejected, (state, action) => {
          state.status = "failed";
          state.error = action.payload;
        })

        .addCase(FetchActivitiesByKeyword.pending, (state) => {
          state.loading = true;
          state.error = null;
        })
        .addCase(FetchActivitiesByKeyword.fulfilled, (state, action) => {
          state.loading = false;
          state.activitiesBD = action.payload;
        })
        .addCase(FetchActivitiesByKeyword.rejected, (state, action) => {
          state.loading = false;
          state.error = action.payload;
        })
        .addCase(FetchFoodPreferencesByKeyword.pending, (state) => {
          state.loading = true;
          state.error = null;
        })
        .addCase(FetchFoodPreferencesByKeyword.fulfilled, (state, action) => {
          state.foodPreferences = action.payload;
          state.loading = false;
        })
        .addCase(FetchFoodPreferencesByKeyword.rejected, (state, action) => {
          state.loading = false;
          state.error = action.payload;
        });
    },
  });
  
  export default exerciseCategoriesSlice.reducer;
  